import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { LoginContext } from "@context/loginContext";
import { OportunityContext } from "@context/oportunityContex";
import { UsuallyContext } from "@context/usuallyContex";
import React from "react";
import { FaAward } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import type { IDashboardRating } from "src/@types/Home";
import { theme } from "src/styles/theme";

interface ICustomRating {
  dataRating: IDashboardRating[];
}

const CustomRating: React.FC<ICustomRating> = React.memo(({ dataRating }) => {
  const navigate = useNavigate();
  const { setPageSidebar } = React.useContext(LoginContext);
  const { setHashSalesSidebar } = React.useContext(UsuallyContext);
  const { setFaseMyOportunity } = React.useContext(OportunityContext);
  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleRanking = React.useCallback((ranking: string) => {
    if (ranking === "Diamante") return "#3DB4AE";
    if (ranking === "Ouro") return "#E69C08";
    else if (ranking === "Prata") return "#878D97";
    else if (ranking === "Bronze") return "#BD6E3D";
     else if (ranking === "Aço") return "#445571";
    else if (ranking === "Não elegível") return "#CFCFCF";
    else if (ranking === "Ranking não disponível") return "#59667A";
    else return "#999999";
  }, []);

  const handleRedirect = React.useCallback(
    (rank: string) => {
      navigate("/oportunidades/minhas-oportunidades");
      setPageSidebar("Minhas oportunidades");
      localStorage.setItem("@option", "Minhas oportunidades");
      setHashSalesSidebar("MyOportunityComponent");
      setFaseMyOportunity([rank]);
    },
    [navigate, setPageSidebar, setHashSalesSidebar, setFaseMyOportunity]
  );

  const memoizedData = React.useMemo(() => dataRating || [], [dataRating]);

  return (
    <>
      <Heading
        as="h3"
        size={{ base: "xs", sm: "sm", md: "md" }}
        mb={{ base: 4, md: 6 }}
        fontWeight={"medium"}
      >
        Rating
      </Heading>
      <VStack
        overflowY={"auto"}
        h={"85%"}
        w={{ base: "fit-content", sm: "fit-content", md: "100%" }}
        align={{ base: "flex-start", sm: "flex-start", md: "center" }}
        spacing={{ base: 2, md: 3 }}
        css={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#D3D3D3",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#A0AEC0",
          },
          "&::-webkit-scrollbar-track": {
            background: "#F7FAFC",
          },
        }}
      >
        {memoizedData?.length === 0 ? (
          <Flex align="center" textAlign={"center"} justify="center" h={"90%"}>
            <Text
              w={"fit-content"}
              color={theme.text50}
              fontSize={{ base: "xs", sm: "sm", md: "md" }}
              px={2}
            >
              Não há ranking nas oportunidades existentes
            </Text>
          </Flex>
        ) : (
          <>
            {memoizedData?.map(({ rank, quantidade }, index: number) => (
              <Flex
                gap={{ base: 2, sm: 3, md: 4 }}
                pb={{ base: 2, sm: 3, md: 6 }}
                align={{ base: "flex-start", sm: "flex-start", md: "center" }}
                key={index}
                w={{ base: "fit-content", sm: "fit-content", md: "100%" }}
              >
                <Box
                  display={"flex"}
                  w={{ base: "35px", sm: "40px", md: "52px" }}
                  h={{ base: "30px", sm: "35px", md: "45px" }}
                  justifyContent={"center"}
                  alignItems={"center"}
                  borderWidth={"1px"}
                  borderRadius={"full"}
                  color={theme.disable}
                  p={2}
                >
                  <FaAward
                    color={handleRanking(rank)}
                    fontSize={isMobile ? "14px" : "20px"}
                  />
                </Box>

                <Box
                  display={"flex"}
                  flexDir={"column"}
                  h={"fit-content"}
                  alignItems={"flex-start"}
                  cursor={"pointer"}
                  onClick={() => handleRedirect(rank)}
                >
                  <Text
                    fontSize={{ base: "2xs", sm: "xs", md: "sm" }}
                    color={theme.text}
                    fontWeight={"medium"}
                    _hover={{
                      textDecoration: "underline",
                    }}
                  >
                    Nível {rank}
                  </Text>
                  <Text
                    fontSize={{ base: "3xs", sm: "2xs", md: "xs" }}
                    color="gray.400"
                  >
                    {quantidade} {quantidade === 1 ? "cliente" : "clientes"}
                  </Text>
                </Box>
              </Flex>
            ))}
          </>
        )}
      </VStack>
    </>
  );
});

export default CustomRating;
